<template>
  <div
    :style="opacity"
    :class="`svg-outer svg-topLayer img-laptop img-all ${page} ${className}`"
    @click="reloadToggle"
  >
    <div class="arc-1" :style="arc1_setter">
      <arc1
        :stroke-color="arc1_color"
        :animate-speed="animationSpeed"
        :parent-clicked="reload"
      />
    </div>
    <div class="arc-2" :style="arc2_setter">
      <arc2
        :stroke-color="arc2_color"
        :animate-speed="animationSpeed"
        :parent-clicked="reload"
      />
    </div>
    <div class="arc-3" :style="arc3_setter">
      <arc3
        :stroke-color="arc3_color"
        :animate-speed="animationSpeed"
        :parent-clicked="reload"
      />
    </div>
    <div ref="circle_md" class="circle-1 top-layer" :style="circle_md" />
    <div ref="circle_sm" class="circle-2 top-layer" :style="circle_sm" />
    <div ref="circle_lg" class="circle-3 top-layer" :style="circle_lg" />
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import Arc1 from "@/components/prospect/brandPattern/arc1.vue";
import Arc2 from "@/components/prospect/brandPattern/arc2.vue";
import Arc3 from "@/components/prospect/brandPattern/arc3.vue";
import $ from "jquery";
@Component({
  components: {
    arc1: Arc1,
    arc2: Arc2,
    arc3: Arc3,
  },
})
export default class BrandPattern2 extends Vue {
  // Data with default values
  reload = true;
  animationSpeed = process.env.VUE_APP_BRANDPATTERN_SPEED
    ? parseInt(process.env.VUE_APP_BRANDPATTERN_SPEED)
    : 1500;
  arc1_color = "#387DFF";
  arc2_color = "#FFFFFF";
  arc3_color = "#FFFFFF";
  circle_small_color = "#FFFFFF";
  circle_medium_color = "#FFFFFF";
  circle_large_color = "#FFFFFF";
  arc1_setter: Record<string, string> = { top: "-48px", right: "0px" };
  arc2_setter: Record<string, string> = { top: "163px", left: "-15px" };
  arc3_setter: Record<string, string> = { top: "220px", right: "30px" };
  circle_sm_setter: Record<string, string> = {
    top: "430px",
    right: "0px",
    background: `${this.circle_small_color}`,
    "animation-duration": `${this.animationSpeed}ms`,
  };
  circle_md_setter: Record<string, string> = {
    top: "430px",
    right: "0px",
    background: `${this.circle_medium_color}`,
    "animation-duration": `${this.animationSpeed}ms`,
  };
  circle_lg_setter: Record<string, string> = {
    top: "430px",
    right: "0px",
    background: `${this.circle_large_color}`,
    "animation-duration": `${this.animationSpeed}ms`,
  };
  opacity_value = 1;

  // Props
  @Prop({ required: true })
  public page!: string;

  @Prop({ required: false })
  public className!: string;

  // Created method
  created() {
    this.setChanges();
  }

  // Computed values
  get opacity() {
    return {
      opacity: `${this.opacity_value}`,
    };
  }
  get arc1Setter() {
    return this.arc1_setter;
  }
  get arc2Setter() {
    return this.arc2_setter;
  }
  get arc3Setter() {
    return this.arc3_setter;
  }
  get circle_sm() {
    return this.circle_sm_setter;
  }
  get circle_md() {
    return this.circle_md_setter;
  }
  get circle_lg() {
    return this.circle_lg_setter;
  }

  // Methods
  setChanges() {
    if (this.page == "MYRESPONSES") {
      this.arc1_color = "#387DFF";
      this.arc2_color = "#FFFFFF";
      this.arc3_color = "#FFFFFF";
      this.circle_small_color = "#FFFFFF";
      this.circle_medium_color = "#48A0FF";
      this.circle_large_color = "#48A0FF";
      this.opacity_value = 1;

      this.arc1_setter = { top: "50px", right: "250px" };
      this.arc2_setter = { top: "250px", left: "210px" };
      this.arc3_setter = { top: "330px", right: "235px" };

      this.circle_sm_setter = {
        top: "20px",
        left: "568px",
        background: `${this.circle_small_color}`,
        "animation-duration": `${this.animationSpeed}ms`,
      };
      this.circle_md_setter = {
        bottom: "200px",
        right: "215px",
        background: `${this.circle_medium_color}`,
        "animation-duration": `${this.animationSpeed}ms`,
      };
      this.circle_lg_setter = {
        bottom: "-42px",
        left: "58px",
        background: `${this.circle_large_color}`,
        "animation-duration": `${this.animationSpeed}ms`,
      };
    } else if (
      this.page == "CREATEACCOUNT" ||
      this.page == "LOGIN" ||
      this.page == "TSA" ||
      this.page == "TSASetup"
    ) {
      this.arc1_color = "#387DFF";
      this.arc2_color = "#FFFFFF";
      this.arc3_color = "#FFFFFF";
      this.circle_small_color = "#FFFFFF";
      this.circle_medium_color = "#FFFFFF";
      this.circle_large_color = "#FFFFFF";
      this.opacity_value = 0.1;

      this.arc1_setter = { top: "10px", right: "200px" };
      this.arc2_setter = { top: "200px", left: "200px" };
      this.arc3_setter = { top: "250px", right: "175px" };

      this.circle_sm_setter = {
        top: "52px",
        left: "485px",

        background: `${this.circle_small_color}`,
        "animation-duration": `${this.animationSpeed}ms`,
      };
      this.circle_md_setter = {
        bottom: "240px",
        right: "150px",
        background: `${this.circle_medium_color}`,
        "animation-duration": `${this.animationSpeed}ms`,
      };
      this.circle_lg_setter = {
        bottom: "-110px",
        left: "58px",
        background: `${this.circle_large_color}`,
        "animation-duration": `${this.animationSpeed}ms`,
      };
    }
  }
  reloadToggle() {
    this.reload = !this.reload;
    $(this.$refs.circle_md as any).removeClass("top-layer");
    $(this.$refs.circle_sm as any).removeClass("top-layer");
    $(this.$refs.circle_lg as any).removeClass("top-layer");
    setTimeout(() => {
      $(this.$refs.circle_md as any).addClass("top-layer");
      $(this.$refs.circle_sm as any).addClass("top-layer");
      $(this.$refs.circle_lg as any).addClass("top-layer");
    }, 0);
  }
}
</script>
<style scoped>
.arc-1 {
  position: absolute;

  height: 120px;
  z-index: 1;
}

.arc-2 {
  position: absolute;
  overflow: hidden;
  width: 100px;
  height: 300px;
  z-index: 1;
}

.arc-3 {
  position: absolute;
  z-index: 1;
  width: 327px;
  height: 400px;
}

.svg-outer {
  position: absolute;
  overflow: hidden;
  height: 102%;
  width: 100%;
  top: -14px;
  left: 0%;
  zoom: 1.2;
  z-index: 0;
}

.top-layer {
  animation-name: circle;
  animation-iteration-count: 1;
  animation-timing-function: linear;
}
.circle-1 {
  width: 60px;
  height: 60px;
  position: absolute;
  border-radius: 50%;
  z-index: 1;
  overflow: hidden;
  background: #48a0ff;
}

.circle-2 {
  width: 26px;
  height: 26px;
  position: absolute;
  border-radius: 50%;
  z-index: 1;
  overflow: hidden;
}

.circle-3 {
  width: 184px;
  height: 184px;
  position: absolute;
  border-radius: 50%;
  z-index: 1;
  overflow: hidden;
}

@keyframes circle {
  from {
    opacity: 0%;
  }

  to {
    opacity: 100%;
  }
}

@media screen and (min-width: 3840px) {
  .svg-outer {
    zoom: 3.5 !important;
  }
}

/*
@media screen and (min-width: 2000px) and (max-width: 3839px), not screen and (min-height:1100) {
  .svg-outer{
    zoom: 1.9 !important;
  }

}

@media screen and (min-width: 2000px) and ( orientation: potrait ) {
  .svg-outer {
    zoom: 1.4 !important;
  }

}*/

@media only screen and (max-width: 3440px) {
  .svg-outer {
    zoom: 1.9;
  }
}

@media only screen and (max-width: 2560px) {
  .svg-outer {
    zoom: 1.8;
  }
}

@media only screen and (max-width: 2048px) {
  .svg-outer {
    zoom: 1.4;
  }
}

@media only screen and (max-width: 1680px) {
  .svg-outer {
    zoom: 1.35;
  }
}

@media only screen and (max-width: 1600px) {
  .svg-outer {
    zoom: 1.1;
  }
}

@media only screen and (max-width: 1366px) {
  .svg-outer {
    zoom: 1;
  }
  .arc-1 {
    right: 55px !important;
  }

  .arc-2 {
    top: 40% !important;
    left: 150px !important;
  }

  .arc-3 {
    right: 70px !important;
    top: 53% !important;
  }
  .circle-2 {
    top: 15% !important;
    left: 41% !important;
  }
  .circle-1 {
    bottom: 15% !important;
  }
}

/*@media only screen and (max-width: 1024px) {
  .svg-outer{
    zoom: 1.2 ;
  }
  .arc-1{
    right:0px;
  }

  .arc-2{
    top:500px;
    left:20px;
  }

  .arc-3{
    right: 30px;
    top: 775px;
  }
  .circle-2{
    left: 290px;
  }
  .circle-1{
    right: 0px;
  }
}*/

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .svg-outer {
    zoom: 1;
  }
  .arc-1 {
    right: 0px !important;
  }

  .arc-2 {
    top: 300px !important;
    left: 50px !important;
  }

  .arc-3 {
    right: 30px !important;
    top: 460px !important;
  }
  .circle-2 {
    left: 380px !important;
    top: 130px !important;
  }
  .circle-1 {
    right: 0px !important;
  }
  .circle-3 {
    bottom: -50px !important;
  }
}

@media only screen and (max-device-width: 768px) {
  .svg-outer {
    display: none !important;
  }
}
</style>
